module.exports = "ul{padding-left:25px}"